/* global $ */
import Headroom from 'headroom.js'

import './jquery.slicknav.js'

import './slicknav.css'

const setSlickNav = async () => {
  var label = 'Valikko'
  if (typeof (lucciLangStrings) === 'object') {
    label = lucciLangStrings.menu_text
  }
  $('#menu').slicknav({
    label: label,
    closedSymbol: '+',
    openedSymbol: '<span class="opened">-</div>',
    closeOnClick: true
  })

  let slickNavElem = document.querySelector('.slicknav_menu')

  $('.slicknav_menu').prepend('<div class="right-container"></div>')
  $('.slicknav_menu').prepend('<div class="left-container"></div>')

  var callToAction = $('.header-content .call-to-action').clone()
  if(callToAction) {
    $('.slicknav_menu  .right-container').append(callToAction)
    var new_clone = $('.header-content .call-to-action').clone()
    $('.slicknav_nav').append(new_clone)
  }

  var somet = $('.header-content .social-media').clone()
  if(somet) {
    $('.slicknav_menu .right-container').prepend(somet)
    var new_some_clone = $('.header-content .social-media').clone()
    $('.slicknav_nav').append(new_some_clone)
  }

  var langs = $('.header-content .languages').clone()
  if(langs) {
    $('.slicknav_menu .left-container').append(langs)
    var new_lang_clone = $('.header-content .languages').clone()
    $('.slicknav_nav').prepend(new_lang_clone)
  }


  let logo = $('.logo').clone() // Get logo
  if (logo) { // Add logo
    $(logo).addClass('slicknav_menu__logo').removeClass('logo')
    $('.slicknav_menu .left-container').prepend(logo)
  }

  /* let slicknav_nav = $('.slicknav_nav')
  if(slicknav_nav) {
    $(slicknav_nav).appendTo('.slicknav_menu .right-container')
  } */
  return slickNavElem
}

const setHeadroom = (slickNavElem) => {
  if (slickNavElem) {
    const headroom = new Headroom(slickNavElem, {
      offset: 100,
      tolerance: 5,
      classes: {
        // When element is initialised
        initial: 'headroom--mobile',
        // When scrolling up
        pinned: 'headroom--pinned--mobile',
        // When scrolling down
        unpinned: 'headroom--unpinned--mobile'
      },
      // Cancel unpin when Slick nav is open
      onUnpin: function () {
        if ($('.slicknav_open')[0]) this.pin()
      }
    })
    headroom.init()
  }
}

const init = async () => {
  await setSlickNav().then(setHeadroom) // Initialize SlickNav, then set headroom
}

export default {
  init
}
